import { buttons, product } from 'copy/copy';
import React, { ReactElement } from 'react';
import { Link } from 'react-router-dom';

interface Props {
  queryParams: string;
}

const SignInSection = (props: Props): ReactElement => {
  return (
    <div className="index-signin">
      <div className="index__container column items-center justify-center">
        <div
          className="flex column items-center center"
          style={{ maxWidth: '380px' }}
        >
          <h2
            className="bold center pt9 pb4"
            style={{ color: '#000', fontSize: '28px', lineHeight: '39.2px' }}
          >
            Discover what {product.productName} can do for your jobsite.
          </h2>
          <Link
            to={`/my-workspace${props.queryParams}`}
            className="btn bold decoration-none flex-center font-size-5"
            style={{
              backgroundColor: '#53A42E',
              borderRadius: '3px',
              margin: '0 auto',
              maxWidth: '200px',
              padding: '0 16px',
            }}
            id="hero-sign-in"
          >
            {buttons.getStarted}
          </Link>
          <span
            className="font-size-2 block mt4 px7"
            style={{ lineHeight: '16.8px' }}
          >
            {product.productName} is only available to trial and purchase for
            customers in the United States at this time.
          </span>
        </div>
      </div>
    </div>
  );
};

export default SignInSection;
